import { Suspense } from 'react';
import { SystemWideBanner } from '@mews/b2b-ui';
import { lt, useFeatureFlag } from '@mews/framework';
import { ArticlePath, createGuideLink, FeatureFlag } from '@mews-commander/enums';
import { NewTabLink } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { WithEnterpriseId } from '@mews-commander/types';
import { useGetOnboardingStatus } from './useGetOnboardingStatus';

const GoLiveBannerBase = ({ enterpriseId }: WithEnterpriseId) => {
    const { data } = useGetOnboardingStatus({ enterpriseId, extent: { actionLogs: false } });

    if (data.goLive !== false) return null;

    return (
        <SystemWideBanner
            variant="info"
            text={lt('OnboardingGoLiveBannerText', {
                link: (text) => (
                    <NewTabLink url={createGuideLink(ArticlePath.MewsOnboardingSystemAudit)}>{text}</NewTabLink>
                ),
            })}
            centered
        />
    );
};

export const GoLiveBanner = () => {
    const isOnboardingGoLiveStatusEnabled = useFeatureFlag(FeatureFlag.onboardingGoLiveStatusEnabled);
    const currentEnterpriseId = useCurrentEnterpriseId();

    if (!isOnboardingGoLiveStatusEnabled || !currentEnterpriseId) return null;

    return (
        <Suspense fallback={null}>
            <GoLiveBannerBase enterpriseId={currentEnterpriseId} />
        </Suspense>
    );
};
